<template>
  <el-dialog class="contract-form-dialog" :title="dialogTitle" :visible.sync="dialogVisible" width="1200px" top="5vh" :close-on-click-modal="false" :before-close="onClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="130px">
      <!-- 顶部基础信息 -->
      <div class="section-title">基础信息</div>
      <el-row :gutter="24">
        <!-- 第一行：发起人 | 申请日期 | 部门 -->
        <el-col :span="8">
          <el-form-item label="发起人" prop="data32">
            <el-input v-model="form.data32" placeholder="请输入发起人" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请日期" prop="data42">
            <el-date-picker v-model="form.data42" type="date" value-format="yyyy-MM-dd" placeholder="选择申请日期" style="width: 100%" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="部门" prop="data33">
            <el-select filterable clearable v-model="form.data33" placeholder="请选择部门" style="width: 100%" :disabled="isReadonly">
              <el-option v-for="item in deptOptions" :key="item.deptId" :label="item.deptName" :value="item.deptName" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 第二行：职务 | 表单号 -->
        <el-col :span="8">
          <el-form-item label="职务" prop="data35">
            <el-input v-model="form.data35" placeholder="请输入职务" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="表单号" prop="data43">
            <el-input v-model="form.data43" placeholder="自动生成" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <!-- 第二行（通栏）：文号 -->
        <el-col :span="24">
          <el-form-item label="文号" prop="runName">
            <el-input v-model="form.runName" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 合同信息 -->
      <div class="section-title">合同信息</div>
      <el-row :gutter="24">
        <!-- 行1：项目名称 | 补充协议 -->
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-select filterable clearable v-model="form.projectName" placeholder="请选择项目" style="width: 100%" @change="handleProjectChange" :disabled="isReadonly">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.projectName" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="补充协议">
            <div style="display: flex; align-items: center;">
              <el-checkbox v-model="form.isSupplementaryAgreement" :disabled="isReadonly" />
              <el-select v-if="form.isSupplementaryAgreement && form.projectId" v-model="form.contractId" placeholder="请选择原合同" filterable style="flex: 1; margin-left: 15px" @change="handleContractChange" :disabled="isReadonly">
                <el-option v-for="item in contractOptions" :key="item.id" :label="item.contractName" :value="item.id" />
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <!-- 行2：合同名称 | 供货方名称 -->
        <el-col :span="12">
          <el-form-item label="合同名称" prop="contractName">
            <el-input v-model="form.contractName" placeholder="示例：乙方公司名-材料名称" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供货方名称" prop="supplierName">
            <el-select filterable clearable v-model="form.supplierName" placeholder="请选择供货方" style="width: 100%" @change="handleSupplierChange" :disabled="isReadonly">
              <el-option v-for="item in supplierOptions" :key="item.id" :label="item.name" :value="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 行3：合同编号 | 合同类别 -->
        <el-col :span="12">
          <el-form-item label="合同编号" prop="contractNo">
            <el-input v-model="form.contractNo" placeholder="请输入合同编号" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同类别" prop="contractType">
            <el-select filterable clearable v-model="form.contractType" placeholder="请选择合同类别" style="width: 100%" :disabled="isReadonly">
              <el-option v-for="item in contractTypeOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 行4：材料名称 | 合同实际结算金额 -->
        <el-col :span="12">
          <el-form-item label="材料名称" prop="materialName">
            <el-input v-model="form.materialName" placeholder="请输入材料名称" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同实际结算金额" prop="finalSettlementAmount">
            <el-input-number v-model="form.finalSettlementAmount" :min="0" :precision="2" :controls="false" placeholder="请输入合同实际结算金额" style="width: 100%" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <!-- 行5：含税合同金额 | 税率(%) -->
        <el-col :span="12">
          <el-form-item label="含税合同金额" prop="contractAmount">
            <el-input-number v-model="form.contractAmount" :min="0" :precision="2" :controls="false" placeholder="请输入含税合同金额" style="width: 100%" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税率(%)" prop="taxRate">
            <el-input-number v-model="form.taxRate" :min="0" :precision="2" :controls="false" placeholder="请输入税率" style="width: 100%" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <!-- 行6：计价方式 | 合同附件 -->
        <el-col :span="12">
          <el-form-item label="计价方式" prop="pricingMethod">
            <el-select clearable v-model="form.pricingMethod" placeholder="请选择计价方式" style="width: 100%" :disabled="isReadonly">
              <el-option label="固定单价" value="固定单价" />
              <el-option label="固定总价" value="固定总价" />
              <el-option label="成本加酬金" value="成本加酬金" />
              <el-option label="定额计价" value="定额计价" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同附件" prop="contractFile">
            <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :limit="5"
              :data="uploadData"
              name="uploadFile"
              :file-list="contractFileList"
              :on-preview="handlePreviewFile"
              :on-success="onUploadSuccess"
              :on-remove="onUploadRemove">
              <el-button v-if="!isReadonly" size="small" type="primary" icon="el-icon-upload2">点击上传</el-button>
              <span style="color: red; margin-left: 10px;">附件最大10M</span>
            </el-upload>
          </el-form-item>
        </el-col>
        <!-- 行7：累计金额 | 合同累计申请金额 -->
        <el-col :span="12">
          <el-form-item label="累计金额" prop="cumulativeAmount">
            <el-input-number v-model="form.cumulativeAmount" :min="0" :precision="2" :controls="false" placeholder="请输入累计金额" style="width: 100%" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同累计申请金额" prop="totalApplyAmount">
            <el-input v-model="form.totalApplyAmount" placeholder="请输入合同累计申请金额" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <!-- 行8：备注（通栏） -->
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="3" v-model="form.remark" placeholder="请输入备注" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 开票信息 -->
      <div class="section-title">开票信息</div>
      <el-row :gutter="24">
        <!-- 行1（通栏）：开票类型 -->
        <el-col :span="24">
          <el-form-item label="开票类型" prop="invoiceType">
            <div style="display: flex; align-items: center;">
              <el-radio-group v-model="form.invoiceType" @change="handleInvoiceTypeChange" :disabled="isReadonly">
                <el-radio :label="1">增值税专用发票</el-radio>
                <el-radio :label="2">增值税普通发票</el-radio>
                <el-radio :label="3">其他</el-radio>
              </el-radio-group>
              <el-input v-if="form.invoiceType === 3" v-model="form.invoiceTypeOther" placeholder="请输入" style="flex: 1; margin-left: 15px" :disabled="isReadonly" />
            </div>
          </el-form-item>
        </el-col>
        <!-- 行2：开票名称 | 纳税人识别号 -->
        <el-col :span="12">
          <el-form-item label="开票名称" prop="invoiceName">
            <el-input v-model="form.invoiceName" placeholder="请输入开票名称" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号" prop="taxpayerId">
            <el-input v-model="form.taxpayerId" placeholder="请输入纳税人识别号" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <!-- 行3：开票地址及电话 | 开户行 -->
        <el-col :span="12">
          <el-form-item label="开票地址及电话" prop="invoiceAddressPhone">
            <el-input v-model="form.invoiceAddressPhone" placeholder="请输入开票地址及电话" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行" prop="bankName">
            <el-input v-model="form.bankName" placeholder="请输入开户行" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
        <!-- 行4：银行账户 | 右侧留空 -->
        <el-col :span="12">
          <el-form-item label="银行账户" prop="bankAccount">
            <el-input v-model="form.bankAccount" placeholder="请输入银行账户" :disabled="isReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 审批记录 -->
    <div v-if="flowTaskCommentList.length">
      <div class="section-title">审批记录</div>
      <el-table :data="flowTaskCommentList" size="small" border header-cell-class-name="table-header-gray">
        <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" />
        <el-table-column label="流程环节" prop="taskName" />
        <el-table-column label="执行人" prop="createUsername" />
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-tag size="small" :type="getOperationTagType(scope.row.approvalType)" effect="dark">{{SysFlowTaskOperationType.getValue(scope.row.approvalType)}}</el-tag>
            <el-tag v-if="scope.row.delegateAssginee != null" size="small" type="success" effect="plain" style="margin-left: 10px;">{{scope.row.delegateAssginee}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审批意见">
          <template slot-scope="scope">
            <img v-if="isImage(scope.row.comment)" style="width:100px;height: 100px;object-fit: contain; cursor: pointer;" :src="scope.row.comment" alt="" @click="handlePreview(scope.row.comment)">
            <el-tooltip v-else-if="scope.row.comment" :content="scope.row.comment" placement="top" :open-delay="300">
              <span>{{scope.row.comment}}</span>
            </el-tooltip>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="处理时间" prop="createTime" />
      </el-table>
    </div>
    <Preview :visible.sync="previewVisible" :list="previewList" :index="0" />
    <div slot="footer">
      <el-button size="medium" @click="onClose">{{ isReadonly ? '关 闭' : '取 消' }}</el-button>
      <el-button v-if="!isReadonly" size="medium" type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Contract } from '@/api/contract'
import { OnlineOperation } from '@/api/onlineController.js'
import { uploadMixin } from '@/core/mixins'
import projectConfig from '@/core/config'
import { LicenseManagement } from '@/api/Licence'
import { FlowEntryController, FlowOperationController } from '@/api/flowController.js'
import '@/staticDict/flowStaticDict.js'
import Preview from '@/components/Files/Preview.vue'
import dayjs from 'dayjs'

// 文号前缀（与合同申请流程入口名称一致）
const FLOW_ENTRY_NAME = '合同管理新流程'

// oa_flow_contract_management 在线表单数据源ID
const CONTRACT_DATASOURCE_ID = '2074056650079080449'
// 在线表单数据源名称（表名），如与后台配置不一致请调整
const CONTRACT_DATASOURCE_NAME = 'oaFlowContractManagement'

const initForm = () => ({
  id: null,
  // 顶部基础信息（与流程页面字段一致，小驼峰）
  data32: '', // 发起人
  data42: '', // 申请日期
  data33: '', // 部门
  data35: '', // 职务
  data43: '', // 表单号
  runName: '', // 文号
  projectId: null,
  projectName: '',
  projectNature: '',
  supplierId: null,
  supplierName: '',
  contractId: null,
  contractName: '',
  contractNo: '',
  contractType: '',
  materialName: '',
  contractAmount: null,
  taxRate: null,
  pricingMethod: '',
  isSupplementaryAgreement: false,
  cumulativeAmount: null,
  finalSettlementAmount: null,
  totalApplyAmount: null,
  invoiceType: null,
  invoiceTypeOther: '',
  invoiceName: '',
  taxpayerId: '',
  invoiceAddressPhone: '',
  bankName: '',
  bankAccount: '',
  remark: '',
  contractFile: ''
})

export default {
  name: 'ContractFormDialog',
  mixins: [uploadMixin],
  components: {
    Preview
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 编辑时的行数据（新增时传 null）
    rowData: {
      type: Object,
      default: null
    },
    // 只读（详情）模式
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      form: initForm(),
      deptOptions: [],
      projectOptions: [],
      supplierOptions: [],
      contractOptions: [],
      contractTypeOptions: ['OA', '材料采购合同', '机械租赁合同', '专业分包合同', '劳务分包合同', '其余各类合同'],
      contractFileList: [],
      flowTaskCommentList: [],
      previewVisible: false,
      previewList: [],
      rules: {
        data32: [
          { required: true, message: '请输入发起人', trigger: 'blur' }
        ],
        data42: [
          { required: true, message: '请选择申请日期', trigger: 'change' }
        ],
        data33: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        data35: [
          { required: true, message: '请输入职务', trigger: 'blur' }
        ],
        data43: [
          { required: true, message: '请输入表单号', trigger: 'blur' }
        ],
        runName: [
          { required: true, message: '请输入文号', trigger: 'blur' }
        ],
        projectName: [
          { required: true, message: '请选择项目名称', trigger: 'change' }
        ],
        supplierName: [
          { required: true, message: '请选择供货方名称', trigger: 'change' }
        ],
        contractNo: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
        ],
        contractType: [
          { required: true, message: '请选择合同类别', trigger: 'change' }
        ],
        contractAmount: [
          { required: true, message: '请输入含税合同金额', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请输入税率', trigger: 'blur' }
        ],
        contractFile: [
          { required: true, message: '请上传合同附件', trigger: 'change' }
        ],
        invoiceType: [
          { required: true, message: '请选择开票类型', trigger: 'change' }
        ],
        invoiceName: [
          { required: true, message: '请输入开票名称', trigger: 'blur' }
        ],
        taxpayerId: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible },
      set (val) { this.$emit('update:visible', val) }
    },
    isEdit () {
      return !!(this.rowData && this.rowData.id)
    },
    isReadonly () {
      return this.readonly
    },
    dialogTitle () {
      if (this.isReadonly) return '合同详情'
      return this.isEdit ? '编辑合同' : '新增合同'
    },
    uploadUrl () {
      return projectConfig.baseUrl + 'admin/online/onlineOperation/uploadDatasource/' + CONTRACT_DATASOURCE_NAME
    },
    uploadHeaders () {
      return this.getUploadHeaders
    },
    // 上传参数写死，与抓包一致：processDefinitionKey + datasourceId + asImage + fieldName
    uploadData () {
      return {
        processDefinitionKey: CONTRACT_DATASOURCE_NAME,
        datasourceId: CONTRACT_DATASOURCE_ID,
        asImage: false,
        fieldName: 'contract_file'
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.resetForm()
        this.loadProjectOptions()
        this.loadSupplierOptions()
        this.loadProcessCommentList()
      }
    }
  },
  created () {
    this.loadDeptOptions()
    this.loadProjectOptions()
    this.loadSupplierOptions()
  },
  methods: {
    // 取行数据字段（兼容 camelCase / snake_case / 多个候选字段名）
    pickRow (row, ...keys) {
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (row[key] != null) return row[key]
      }
      return undefined
    },
    loadProcessCommentList () {
      this.flowTaskCommentList = []
      if (!this.isEdit) return
      const processInstanceId = this.pickRow(this.rowData, 'processInstanceId', 'process_instance_id', 'processInstanceID')
      if (processInstanceId == null || processInstanceId === '') {
        console.warn('[ContractFormDialog] 行数据缺少 processInstanceId 字段，无法加载审批记录，请检查 getContractList 接口返回字段', this.rowData)
        return
      }
      FlowOperationController.listFlowTaskComment(this, {
        processInstanceId
      }).then(res => {
        this.flowTaskCommentList = res.data || []
      }).catch(e => {})
    },
    handlePreview (src) {
      this.previewList = [src]
      this.previewVisible = true
    },
    getOperationTagType (type) {
      switch (type) {
        case this.SysFlowTaskOperationType.AGREE:
        case this.SysFlowTaskOperationType.MULTI_AGREE:
        case this.SysFlowTaskOperationType.SET_ASSIGNEE:
          return 'success';
        case this.SysFlowTaskOperationType.REFUSE:
        case this.SysFlowTaskOperationType.PARALLEL_REFUSE:
        case this.SysFlowTaskOperationType.MULTI_REFUSE:
          return 'warning';
        case this.SysFlowTaskOperationType.STOP:
        case this.SysFlowTaskOperationType.REJECT:
        case this.SysFlowTaskOperationType.REJECT_TO_START:
        case this.SysFlowTaskOperationType.REVOKE:
          return 'danger';
        default:
          return 'primary';
      }
    },
    // 判断是否为图片（Base64 或 URL）
    isImage (value) {
      if (!value || value === null || value === '') {
        return false;
      }
      // 1. 判断带前缀的 Base64
      if (value.startsWith('data:image/') && value.includes(';base64,')) {
        return true;
      }
      // 2. 判断图片 URL（放宽条件）
      if (/^https?:\/\//i.test(value)) {
        const imageKeywords = /\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)/i;
        const imageParams = /[?&](w|h|width|height|size|thumb|image|img)/i;
        if (imageKeywords.test(value) || imageParams.test(value)) {
          return true;
        }
        const cdnKeywords = /(img|image|pic|photo|cdn)/i;
        if (cdnKeywords.test(value)) {
          return true;
        }
      }
      // 3. 纯 Base64（较长、包含 + / = 特征）
      if (value.length > 200 && /^[A-Za-z0-9+/=]+$/.test(value)) {
        return true;
      }
      return false;
    },
    resetForm () {
      if (this.isEdit) {
        const row = this.rowData
        this.form = {
          ...initForm(),
          id: row.id,
          // 顶部基础信息（小驼峰）
          data32: row.data32 || '', // 发起人
          data42: row.data42 || '', // 申请日期
          data33: row.data33 || '', // 部门
          data35: row.data35 || '', // 职务
          data43: row.data43 || '', // 表单号
          runName: row.runName || '', // 文号
          projectId: this.pickRow(row, 'projectId', 'project_id'),
          projectName: this.pickRow(row, 'projectName', 'project_name'),
          projectNature: this.pickRow(row, 'projectNature', 'project_nature'),
          supplierId: this.pickRow(row, 'supplierId', 'supplier_id'),
          supplierName: this.pickRow(row, 'supplierName', 'supplier_name'),
          contractId: this.pickRow(row, 'contractId', 'contract_id'),
          contractName: this.pickRow(row, 'contractName', 'contract_name'),
          contractNo: this.pickRow(row, 'contractNo', 'contract_no'),
          contractType: this.pickRow(row, 'contractType', 'contract_type'),
          materialName: this.pickRow(row, 'materialName', 'material_name'),
          contractAmount: this.pickRow(row, 'contractAmount', 'contract_amount'),
          taxRate: this.pickRow(row, 'taxRate', 'tax_rate'),
          pricingMethod: this.pickRow(row, 'pricingMethod', 'pricing_method'),
          isSupplementaryAgreement: !!this.pickRow(row, 'isSupplementaryAgreement', 'is_supplementary_agreement'),
          cumulativeAmount: this.pickRow(row, 'cumulativeAmount', 'cumulative_amount'),
          finalSettlementAmount: this.pickRow(row, 'finalSettlementAmount', 'final_settlement_amount'),
          totalApplyAmount: this.pickRow(row, 'totalApplyAmount', 'total_apply_amount'),
          invoiceType: this.pickRow(row, 'invoiceType', 'invoice_type'),
          invoiceTypeOther: this.pickRow(row, 'invoiceTypeOther', 'invoice_type_other'),
          invoiceName: this.pickRow(row, 'invoiceName', 'invoice_name'),
          taxpayerId: this.pickRow(row, 'taxpayerId', 'taxpayer_id'),
          invoiceAddressPhone: this.pickRow(row, 'invoiceAddressPhone', 'invoice_address_phone'),
          bankName: this.pickRow(row, 'bankName', 'bank_name'),
          bankAccount: this.pickRow(row, 'bankAccount', 'bank_account'),
          remark: this.pickRow(row, 'remark', 'remark'),
          contractFile: this.pickRow(row, 'contractFile', 'contract_file')
        }
        // 回显附件（补下载地址，生成可预览/下载的 url）
        this.contractFileList = this.parseUploadData(JSON.stringify(this.normalizeFileList(this.form.contractFile)), this.uploadData)
        // 编辑补充协议时回显原合同下拉
        if (this.form.isSupplementaryAgreement && this.form.projectId) {
          this.loadContractOptions(this.form.projectId)
        }
      } else {
        this.form = initForm()
        this.contractFileList = []
        this.generateFormNo()
        this.generateRunName()
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    loadDeptOptions () {
      LicenseManagement.getDeptList(this, {}).then(res => {
        this.deptOptions = (res.data && res.data.dataList) || []
      })
    },
    // 自动生成表单号（与流程表单 data43 一致）
    generateFormNo () {
      if (this.isEdit) return
      FlowEntryController.getFormNo(this).then(rs => {
        if (rs.success && !this.form.data43) {
          this.form.data43 = rs.data
        }
      })
    },
    // 自动生成文号（与流程表单 runName 一致）
    generateRunName () {
      if (this.isEdit) return
      const userInfo = this.$store.getters.getUserInfo
      const showName = userInfo && userInfo.showName ? userInfo.showName : ''
      this.form.runName = `${FLOW_ENTRY_NAME}（${dayjs().format('YYYY年MM月DD日 HH:mm')}）${showName}`
    },
    loadProjectOptions () {
      Contract.getContractProjectList(this, {}).then(res => {
        this.projectOptions = res.data.dataList || []
      })
    },
    loadSupplierOptions () {
      OnlineOperation.listDict(this, {
        dictId: '2064602753610551296'
      }).then(res => {
        this.supplierOptions = res.data || []
      })
    },
    loadContractOptions (projectId) {
      Contract.getContractListByProjectId(this, {
        projectId
      }).then(res => {
        // 已结算的原合同不可再作为补充协议原合同
        this.contractOptions = (res.data || []).filter(item => !item.finalSettlementAmount)
      })
    },
    handleProjectChange (value) {
      const pro = this.projectOptions.find(item => item.projectName === value)
      if (pro) {
        this.form.projectId = pro.id
        this.form.projectNature = pro.projectNature || pro.project_nature
      } else {
        this.form.projectId = null
        this.form.projectNature = ''
      }
      // 切换项目后清空并重新加载原合同
      this.form.contractId = null
      this.form.cumulativeAmount = null
      if (this.form.projectId) {
        this.loadContractOptions(this.form.projectId)
      } else {
        this.contractOptions = []
      }
    },
    // 选择供货方：自动填充开票信息
    handleSupplierChange (value) {
      const supplier = this.supplierOptions.find(item => item.name === value)
      this.form.supplierId = supplier ? supplier.id : null
      if (supplier && supplier.id) {
        this.getSupplierInfo(supplier.id)
      }
    },
    // 选择原合同：自动填充供货方、累计金额及开票信息
    handleContractChange (value) {
      const contract = this.contractOptions.find(item => item.id === value)
      if (!contract) return
      Contract.sumContractAmount(this, { contractId: value }).then(res => {
        this.form.cumulativeAmount = res.data
      })
      if (contract.supplierId) {
        this.getSupplierInfo(contract.supplierId)
      }
    },
    // 根据供货方自动填充开票信息
    getSupplierInfo (id) {
      Contract.getSupplierById(this, {
        id
      }).then(res => {
        const data = res.data || {}
        this.form.supplierId = data.id
        this.form.supplierName = data.companyName
        this.form.invoiceName = data.kaipiaoName
        this.form.taxpayerId = data.nashuiNumber
        this.form.invoiceAddressPhone = data.kaipiaoAddress
        this.form.bankName = data.bank
        this.form.bankAccount = data.bankNumber
      })
    },
    handleInvoiceTypeChange (value) {
      if (value !== 3) this.form.invoiceTypeOther = ''
    },
    onUploadSuccess (res, file) {
      if (res.success) {
        const item = {
          name: file.name,
          filename: res.data.filename,
          downloadUri: res.data.downloadUri || this.getContractDownloadPrefix()
        }
        const [parsed] = this.parseUploadData(JSON.stringify([item]), this.uploadData)
        this.contractFileList.push(parsed || item)
        this.form.contractFile = this.fileListToJson(this.contractFileList)
        this.$refs.form && this.$refs.form.validateField('contractFile')
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    onUploadRemove (file) {
      this.contractFileList = this.contractFileList.filter(item => item.name !== file.name)
      this.form.contractFile = this.contractFileList.length ? this.fileListToJson(this.contractFileList) : ''
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('contractFile')
      })
    },
    // 合同附件下载地址前缀（与上传 uploadDatasource 对应）
    getContractDownloadPrefix () {
      return '/admin/online/onlineOperation/downloadDatasource/' + CONTRACT_DATASOURCE_NAME
    },
    // 兼容旧数据：附件 JSON 缺 downloadUri 时补默认下载地址
    normalizeFileList (jsonData) {
      let list = []
      try {
        list = JSON.parse(jsonData || '[]')
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) list = []
      return list.map(item => ({
        ...item,
        downloadUri: item.downloadUri || this.getContractDownloadPrefix()
      }))
    },
    // 附件预览/下载（el-upload on-preview）
    handlePreviewFile (file) {
      let url = file.url || file.downloadUri
      if (!url) {
        this.$message.warning('附件暂不可预览')
        return
      }
      // 下载接口必须携带 dataId（在线表单记录主键），缺了会返回 403/404
      if (url.indexOf('dataId=') === -1) {
        const dataId = this.form.id
        if (!dataId) {
          this.$message.warning('合同尚未保存，暂无法预览附件')
          return
        }
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'dataId=' + dataId
      }
      window.open(url,'_blank')
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.loading = true
        const data = {
          ...this.form,
          contractFile: this.form.contractFile || '',
          isSupplementaryAgreement: this.form.isSupplementaryAgreement ? 1 : 0
        }
        // 新增时不传 id
        if (!this.isEdit) delete data.id
        const request = this.isEdit
          ? Contract.updateContract(this, data)
          : Contract.addContract(this, data)
        request.then(res => {
          this.loading = false
          if (res.success) {
            this.$message.success(this.isEdit ? '编辑合同成功' : '新增合同成功')
            this.$emit('success', res)
            this.onClose()
          } else {
            this.$message.error((res.data && res.data.msg) || '保存失败')
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    onClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-form-dialog {
  ::v-deep .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
  }

  ::v-deep .el-dialog__body {
    padding: 0 24px;
    max-height: 65vh;
    overflow-y: auto;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  .section-title {
    position: relative;
    margin: 20px 0 10px;
    padding-left: 12px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      background-color: #409EFF;
      border-radius: 2px;
    }
  }

  .el-form-item {
    margin-bottom: 18px;
  }

  ::v-deep .el-input-number {
    width: 100%;
  }
}
</style>
